import type { IconData } from '@stacksjs/iconify-core'

export const toiletSignManFlat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M17.5 8.5a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0m6.5 8c-2.628 0-4.592.102-5.975.217c-1.82.151-3.318 1.355-3.89 3.08a54.8 54.8 0 0 0-2.386 10.785c-.218 1.888 1.201 3.518 3.08 3.636c.547.034 1.164.07 1.842.103l.657 8.866c.119 1.605 1.325 2.945 2.959 3.11q.453.046.957.086a1.48 1.48 0 0 0 1.591-1.422l.375-8.982a.5.5 0 0 1 .5-.479h.58a.5.5 0 0 1 .5.48l.375 8.982a1.48 1.48 0 0 0 1.59 1.42q.505-.04.959-.086c1.634-.164 2.84-1.504 2.96-3.11l.656-8.865q1.018-.052 1.842-.103c1.879-.118 3.297-1.748 3.08-3.636a54.8 54.8 0 0 0-2.386-10.784c-.573-1.726-2.07-2.93-3.89-3.081C28.593 16.6 26.629 16.5 24 16.5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletSignManFlat
